import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { createTokenRefreshController } from "./tokenRefreshController";
import { useAuthorizationStore } from "../../../store/authorizationStore";

export function NewTokenRefresher() {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;
  const epoch = useAuthorizationStore(state => state.epoch);

  useEffect(() => {
    const controller = createTokenRefreshController(epoch, (path, options) => {
      navigateRef.current(path, options);
    });

    window.addEventListener("focus", controller.runRefreshCheck);
    document.addEventListener("visibilitychange", controller.runRefreshCheck);
    controller.runRefreshCheck();

    return () => {
      controller.stop();
      window.removeEventListener("focus", controller.runRefreshCheck);
      document.removeEventListener("visibilitychange", controller.runRefreshCheck);
    };
  }, [epoch]);

  return null;
}
